import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import styles from "./TermsOfService.module.css";

/**
 * TermsOfService Component
 * Displays the official Terms of Service document (Google Doc embed).
 * Linked from login page and visible without authentication.
 */
const TermsOfService: React.FC = () => {
  return (
    <div className={styles.tosPageWrapper}>
      <Container fluid className={`${styles.tosContainer} justify-content-center`}>
        <h2 className={styles.tosTitle}>Terms of Service</h2>

        <iframe
          title="Terms of Service"
          src="https://view.officeapps.live.com/op/embed.aspx?src=https://cygnusworkflow.blob.core.windows.net/cygnusai-documents/CygnusAI_General_Terms_of_Service_v1.0.docx"
          className={styles.tosIframe}
          allowFullScreen
        />

        <div className={styles.tosFooterLink}>
          <Link to="/login">← Back to Login</Link>
        </div>
      </Container>
    </div>
  );
};

export default TermsOfService;
